module.exports = __webpack_public_path__ + "fonts/fa-regular-400.65b9977.ttf";